import { Resources } from 'constants/resources';

import { ResourceProps } from 'react-admin';

import { UsersCreate } from './UsersCreate/UsersCreate';
import { UsersEdit } from './UsersEdit/UsersEdit';
import { UsersList } from './UsersList/UsersList';
import { UsersShow } from './UsersShow/UsersShow';

export const usersResource: ResourceProps = {
  name: Resources.Users,
  create: UsersCreate,
  edit: UsersEdit,
  list: UsersList,
  show: UsersShow,
};
